import {invertColor} from '../Common/tools';
import {
  BOOKING_ANSWERS,
  BUTTON,
  COUNTDOWN_TIMER,
  COUPON_CODE,
  COUPON_CODE_BLOCK,
  FOOTER_ONE,
  FOOTER_THREE,
  FOOTER_TWO,
  HEADING_ONE,
  HERO_IMAGE,
  HERO_OVERLAY_IMAGE,
  IMAGE,
  IMAGE_HEADER,
  IMAGE_MENU_HEADER,
  IMAGE_MENU_HORIZONTAL,
  IMAGE_TEXT,
  CART_DETAILS,
  ORDER_DETAILS,
  DOWNLOAD,
  PARAGRAPH_ONE,
  PARAGRAPH_TWO,
  SEPARATOR,
  SIMPLE,
  STORE_PRODUCT_ONE,
  STORE_PRODUCT_TWO,
  TESTIMONIAL_DOUBLE,
  TESTIMONIAL_SINGLE,
  TEXT_BUTTON,
  TEXT_BUTTON_HORIZONTAL,
  UNSUBSCRIBE,
  VIDEO,
  VIDEO_TEXT,
  WL_LOGO
} from "./const";

import ImageHeader from './Components/ImageHeader.svelte';
import TextButtonBlock from './Components/TextButtonBlock.svelte';
import ImageMenuHeader from './Components/ImageMenuHeader.svelte';
import Image from './Components/Image.svelte';
import Button from './Components/Button.svelte';
import TextButtonHorizontal from './Components/ButtonTextHorizontal.svelte';
import ImageText from './Components/ImageText.svelte';
import HeroOverlayImage from './Components/HeroOverlayImage.svelte';
import HeroImage from './Components/HeroImage.svelte';
import StoreProductsOne from './Components/StoreProductsOne.svelte';
import StoreProductTwo from './Components/StoreProductTwo.svelte';
import TestimonialDouble from './Components/TestimonialDouble.svelte';
import TestimonialSingle from './Components/TestimonialSingle.svelte';
import CouponCodeBlock from './Components/CouponCodeBlock.svelte';
import CouponCode from './Components/CouponCode.svelte';
import ImageMenuHorizontal from './Components/ImageMenuHorizontal.svelte';
import Separator from './Components/Separator.svelte';
import ParagraphTwo from './Components/ParagraphTwo.svelte';
import Video from './Components/Video.svelte';
import VideoText from './Components/VideoText.svelte';
import FooterOne from './Components/FooterOne.svelte';
import FooterTwo from './Components/FooterTwo.svelte';
import FooterThree from './Components/FooterThree.svelte';
import Unsubscribe from './Components/Unsubscribe.svelte';
import CountdownTimer from './Components/CountdownTimer.svelte';
import WLImageHeader from './Components/WLImageHeader.svelte';
import CartDetails from './Components/CartDetails.svelte';
import OrderDetails from './Components/OrderDetails.svelte';
import Download from './Components/Download.svelte';

import TextButtonToolBox from './ToolBox/TextButtonBlock.svelte';
import ImageHeaderControl from './ToolBox/ImageHeader.svelte';
import ImageMenuHeaderControl from './ToolBox/ImageMenuHeader.svelte';
import ImageControl from './ToolBox/Image.svelte';
import ButtonControl from './ToolBox/Button.svelte';
import TextButtonHorizontalControl from './ToolBox/ButtonTextHorizontal.svelte';
import ImageTextControl from './ToolBox/ImageText.svelte';
import HeroOverlayImageControl from './ToolBox/HeroOverlayImage.svelte';
import HeroImageControl from './ToolBox/HeroImage.svelte';
import StoreProductsOneControl from './ToolBox/StoreProductsOne.svelte';
import StoreProductTwoControl from './ToolBox/StoreProductTwo.svelte';
import TestimonialDoubleControl from './ToolBox/TestimonialDouble.svelte';
import TestimonialSingleControl from './ToolBox/TestimonialSingle.svelte';
import CouponCodeControl from './ToolBox/CouponCode.svelte';
import SeparatorControl from './ToolBox/Separator.svelte';
import VideoControl from './ToolBox/Video.svelte';
import FooterOneControl from './ToolBox/FooterOne.svelte';
import UnsubscribeControl from './ToolBox/Unsubscribe.svelte';
import CountdownTimerControl from './ToolBox/CountdownTimer.svelte';
import WLImageHeaderControl from './ToolBox/WLImageHeader.svelte';
import BookingAnswersControl from './ToolBox/BookingAnswers.svelte';
import OrderDetailsControl from './ToolBox/OrderDetails.svelte';
import DownloadControl from './ToolBox/Download.svelte';
import {External, M} from "../external";

function generateButtonBackground() {
  return External.Tools.rgbaToHexNoAlpha(External.GlobalStyling.getColorFromClass('primary'));
}

function generateButtonColors() {
  const background = generateButtonBackground();
  return {
    backgroundColor: background,
    color: invertColor(background, true)
  }
}

function generateButtonStyle() {
  const background = generateButtonBackground();
  return {
    backgroundColor: background,
    color: invertColor(background, true),
    fontFamily: 'Arial',
    fontSize: '16',
    lineHeight: '1.6',
    fontWeight: '400',
    position: 'left'
  }
}

/**
 * Initial structure of the component
 * @param component name
 * @returns component structure
 */
export function componentStructure(component, features) {
  features = features || {};
  let defaultLink = features.defaultLink || '';
  switch (component) {
    case TEXT_BUTTON:
      return {
        type: component,
        content: '<div style="color: #1F2225; font-size: 28px; font-weight: 700; line-height: 1.4;">' + M.SAMPLE_HELLO_TEXT + '<br/><br/></div>' +
            '<div style="color: #969AA1; font-size: 18px; line-height: 1.5; margin-bottom: 40px;"><span style="color: #969AA1; font-weight: normal; font-size: 18px; line-height: 28px; margin-bottom: 40px;">' + M.LOREM_IPSUM + '</span></div>',
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        style: {
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
        buttonStyle: generateButtonColors()
      };
    case IMAGE_HEADER:
      return {
        type: component,
        base: '',
        file: '',
        link: defaultLink,
        style: {
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case IMAGE_MENU_HORIZONTAL:
    case IMAGE_MENU_HEADER:
      return {
        type: component,
        base: '',
        file: '',
        link: defaultLink,
        menu: [
          {caption: M.SAMPLE_MENU_ITEM_1_TEXT, link: ''},
          {caption: M.SAMPLE_MENU_ITEM_2_TEXT, link: ''},
          {caption: M.SAMPLE_MENU_ITEM_3_TEXT, link: ''},
          {caption: M.SAMPLE_MENU_ITEM_4_TEXT, link: ''},
        ],
        style: {
          position: 'center',
          backgroundColor: '#ffffff',
          color: '#000000',
          width: 139,
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case IMAGE:
      return {
        type: component,
        base: '',
        file: '',
        isFullscreen: true,
        hasLink: false,
        style: {
          width: '100%',
          color: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case VIDEO:
      return {
        type: component,
        base: '',
        file: '',
        link: defaultLink,
        isFullscreen: true,
        hasLink: true,
        style: {
          backgroundColor: '#ffffff'
        }
      };
    case VIDEO_TEXT:
      return {
        type: component,
        base: '',
        file: '',
        link: defaultLink,
        content: '<div style="color: #000000; font-size:36px; font-weight: 700; line-height: 1.2; margin: 30px 0 20px 0; text-align: center;"><span style="font-size: 46px;">' + M.SAMPLE_HEADING_SECTION_TEXT + '</span></div>' +
            '<div style="color: #000000; font-size: 18px; line-height: 1.2; text-align: center;font-weight: normal;"><span style="color: #000000; font-size: 18px; line-height: 1.2; text-align: center;font-weight: normal;">' + M.SAMPLE_HEADING_TEXT + '</span></div>',
        isFullscreen: true,
        hasLink: true,
        style: {
          backgroundColor: '#ffffff',
          color: '#000000',
          paddingTop: '120px',
          paddingBottom: '120px',
        }
      };
    case BUTTON:
      return {
        type: component,
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px; text-align: center;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        style: {
          backgroundColor: '#ffffff',
          color: '#000000',
          paddingTop: '10px',
          paddingBottom: '10px',
        },
        buttonStyle: {
          ...generateButtonColors(),
          position: 'center',
        }
      };
    case TEXT_BUTTON_HORIZONTAL:
      return {
        type: component,
        content: '<div style="color: #000000; font-size: 16px; line-height: 23px">' + M.SAMPLE_EMAIL_TEXT_SHORT + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        switched: false,
        buttonStyle: generateButtonColors()
      };
    case IMAGE_TEXT:
      return {
        type: component,
        content: '<div style="color: #000000; line-height: 1.3;; font-size: 20px; ">' + M.SAMPLE_HEADING_TEXT + '<br/><br/></div>' +
            '<div style="font-size: 14px; color: #000000; line-height: 23px; margin-bottom: 20px;"><span style="font-size: 14px; color: #000000; line-height: 23px; margin-bottom: 20px;">' + M.SAMPLE_EMAIL_TEXT_SHORT + '</span></div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
        base: '',
        file: '',
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        switched: false,
        buttonStyle: generateButtonColors()
      };
    case HERO_OVERLAY_IMAGE:
      return {
        type: component,
        isFullscreen: true,
        content: '<div style="font-size: 14px; font-weight: 400; color: #000; line-height: 1.3; text-align: center;"><span style="font-size: 14px; font-weight: 400; line-height: 1.3; text-align: center;">' + M.SAMPLE_HEADING_TOP_TEXT + '</span></div>' +
            '<div style="font-size: 32px; font-weight: 700; line-height: 1.4; margin-bottom: 20px; margin-top: 10px; text-align: center;"><span class="font-size: 46px;font-weight: 700; line-height: 1.4; text-align: center;">' + M.SAMPLE_HEADING_SECTION_TEXT + '</span></div>' +
            '<div style="font-size: 18px; font-weight: 400; line-height: 1.4; text-align: center;"><span style="font-size: 18px; font-weight: 400; line-height: 1.4; text-align: center;">' + M.SAMPLE_EMAIL_TEXT_SHORT + '</span></div>',
        base: '',
        file: '',
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '143px',
          paddingBottom: '143px',
        },
        buttonStyle: {
          ...generateButtonColors(),
          position: 'center'
        }
      };
    case HERO_IMAGE:
      return {
        type: component,
        isFullscreen: false,
        content: '<div style="text-align: center; color: #969AA1; line-height: 23px; font-size: 14px; font-weight: 700; margin-bottom: 7px;">' + M.SAMPLE_HEADING_TOP_TEXT + '</div>' +
            '<div style="text-align: center; color: #000000; font-size: 32px; font-weight: 700; line-height: 50px; margin-bottom: 20px;"><span style="font-size: 42px;">' + M.SAMPLE_HEADING_SECTION_TEXT + '</span></div>',
        base: '',
        file: '',
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 1.4; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '0px',
          paddingBottom: '0px',
        },
        buttonStyle: {
          ...generateButtonColors(),
          position: 'center'
        }
      };
    case STORE_PRODUCT_ONE:
      return {
        type: component,
        isFullscreen: false,
        left: {
          hasLink: true,
          content: '<div style="line-height: 23px; color: #1F2225; font-size: 19px; font-weight: 700; text-decoration: none;">' + M.SAMPLE_PRODUCT_NAME_TEXT + ' <div style="color: #666666; font-size: 16px; line-height: 1.3;"><strike>$99.00</strike> $79.00</div>',
          base: '',
          file: '',
          link: defaultLink
        },
        right: {
          hasLink: true,
          content: '<div style="line-height: 23px; color: #1F2225; font-size: 19px; font-weight: 700; text-decoration: none;">' + M.SAMPLE_PRODUCT_NAME_TEXT + ' <div style="color: #666666; font-size: 16px; line-height: 1.3;"><strike>$99.00</strike> $79.00</div>',
          base: '',
          file: '',
          link: defaultLink
        },
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
      };
    case STORE_PRODUCT_TWO:
      return {
        type: component,
        switched: false,
        isFullscreen: true,
        hasLink: true,
        content: '<div style="font-size: 24px; color: #1F2225; line-height: 30px; font-weight: 700;"><span>' + M.SAMPLE_PRODUCT_NAME_TEXT + '</span></div>' +
            '<div style="color: #666666; font-size: 16px; font-weight: 400; line-height: 23px; margin-bottom: 30px;"><strike style="color: #969AA1;">$149</strike> $79</div>' +
            '<div style="line-height: 23px;font-size: 16px;">' + M.SAMPLE_PRODUCT_DESCR_TEXT + '</div>',
        base: '',
        file: '',
        link: defaultLink,
        text: '<div style="color: #ffffff; line-height: 23px; font-size: 14px;">' + M.SAMPLE_CALL_TO_ACTION_TEXT + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
        buttonStyle: generateButtonColors()
      };
    case TESTIMONIAL_DOUBLE:
      return {
        type: component,
        left: {
          content: '<div style="color: #000000; font-size: 16px; line-height: 26px;">' + M.LOREM_IPSUM +
              '<div style="color: #666666; margin-top: 30px;">' + M.LOREM_IPSUM_SHORT + '</div></div>',
          base: '',
          file: '',
        },
        right: {
          content: '<div style="color: #000000; font-size: 16px; line-height: 26px;">' + M.LOREM_IPSUM +
              '<div style="color: #666666; margin-top: 30px;">' + M.LOREM_IPSUM_SHORT + '</div></div>',
          base: '',
          file: '',
        },
        style: {
          color: '#f1f1f1',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case TESTIMONIAL_SINGLE:
      return {
        type: component,
        content: '<div style="text-align: center; color: #000000;font-size: 20px; line-height: 30px; margin: 20px 0 40px 0;">' + M.LOREM_IPSUM + '</div>' +
            '<div style="text-align: center; color: #666666;font-size: 14px;line-height: 23px;">' + M.LOREM_IPSUM_SHORT + '</div>',
        base: '',
        file: '',
        style: {
          color: '#f1f1f1',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case COUPON_CODE_BLOCK:
      return {
        type: component,
        content: '<div style="color: #1F2225; font-size: 28px; font-weight: 700; line-height: 50px; margin-bottom: 30px;">' + M.SAMPLE_HELLO_TEXT + '</div>' +
            '<div style="color: #969AA1; font-size: 18px; line-height: 28px; margin-bottom: 40px;">' + M.LOREM_IPSUM + '</div>',
        code: '30PROMO',
        style: {
          position: 'left',
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case COUPON_CODE:
      return {
        type: component,
        code: '30PROMO',
        style: {
          position: 'center',
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case SEPARATOR:
    case BOOKING_ANSWERS:
      return {
        type: component,
        isFullscreen: true,
        style: {
          backgroundColor: '#ffffff',
          height: '80px',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case HEADING_ONE:
      return {
        content: '<div style="font-size: 32px; line-height: 1.3; text-align: center; font-weight: 700;">' + M.SAMPLE_HEADING_SECTION_TEXT + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '25px',
          paddingBottom: '25px'
        }
      };
    case PARAGRAPH_ONE:
      return {
        content: '<div style="font-size: 16px; line-height: 1.6; text-align: center; font-weight: normal;">' + M.LOREM_IPSUM + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '25px',
          paddingBottom: '25px'
        }
      };
    case PARAGRAPH_TWO:
      return {
        type: component,
        left: '<div style="font-size: 16px; line-height: 1.6;">' + M.LOREM_IPSUM + '</div>',
        right: '<div style="font-size: 16px; line-height: 1.6;">' + M.LOREM_IPSUM + '</div>',
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '25px',
          paddingBottom: '25px'
        }
      };
    case FOOTER_ONE:
      return {
        type: component,
        content: '<div style="font-size: 16px; line-height: 1.6; text-align: center">' + M.SAMPLE_EMAIL_DISCLAIMER_TEXT + '</div>',
        footer: '<div style="font-size: 16px; line-height: 1.6; text-align: center; color: #969AA1; font-weight: 400;">' + M.SAMPLE_ALL_RIGHTS_RESERVED_TEXT + '</div>',
        base: '',
        file: '',
        link: defaultLink,
        label: M.UNSUBSCRIBE,
        menuTheme: 'dark',
        menu: [
          {type: 'fb', link: 'https://www.facebook.com'},
          {type: 'tw', link: 'https://www.x.com'}
        ],
        style: {
          color: '#969AA1',
          brandColor: '#969AA1',
          backgroundColor: '#ffffff',
          position: 'center',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case FOOTER_TWO:
    case FOOTER_THREE:
      return {
        type: component,
        content: '<div style="color: #969AA1; font-size: 16px; line-height: 1.6; text-align: left">' + M.SAMPLE_EMAIL_DISCLAIMER_TEXT + '</div>',
        footer: '<div style="font-size: 13px; color: #969AA1; font-weight: 400; text-align: left;">' + M.SAMPLE_ALL_RIGHTS_RESERVED_TEXT + ' <a href="" style="color: #969AA1; text-decoration: none;">Terms &amp; Conditions</a> | </div>',
        base: '',
        file: '',
        link: defaultLink,
        label: M.UNSUBSCRIBE,
        menuTheme: 'light',
        menu: [
          {type: 'fb', link: 'https://www.facebook.com'},
          {type: 'tw', link: 'https://www.x.com'}
        ],
        style: {
          color: '#969AA1',
          brandColor: '#969AA1',
          backgroundColor: '#1F2225',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case UNSUBSCRIBE:
      return {
        type: component,
        label: M.UNSUBSCRIBE,
        style: {
          position: 'center',
          paddingTop: '20px',
          paddingBottom: '20px',
          color: '#969AA1',
          brandColor: '#969AA1',
          backgroundColor: '#ffffff'
        }
      };
    case COUNTDOWN_TIMER:
      return {
        type: component,
        endDate: 0,
        theme: 'light',
        days: '<div style="text-align:center;font-size:13px;color:#000000;">' + M.DAYS + '</div>',
        hours: '<div style="text-align:center;font-size:13px;color:#000000;">' + M.HOURS + '</div>',
        minutes: '<div style="text-align:center;font-size:13px;color:#000000;">' + M.MINUTES + '</div>',
        seconds: '<div style="text-align:center;font-size:13px;color:#000000;">' + M.SECONDS + '</div>',
        style: {
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case WL_LOGO:
      return {
        type: component,
        style: {
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };
    case CART_DETAILS:
      return {
        type: component,
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };

    case ORDER_DETAILS:
      return {
        type: component,
        heading1: {
          style: {
            fontFamily: 'Arial',
            fontSize: '16',
            lineHeight: '1.6',
            color: '#44474f',
            fontWeight: '700'
          }
        },
        heading2: {
          style: {
            fontFamily: 'Arial',
            fontSize: '16',
            lineHeight: '1.6',
            color: '#44474f',
            fontWeight: '400'
          }
        },
        body: {
          style: {
            fontFamily: 'Arial',
            fontSize: '16',
            lineHeight: '1.6',
            color: '#969aa1',
            fontWeight: '400'
          }
        },
        style: {
          color: '#44474f',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };

    case DOWNLOAD:
      return {
        type: component,
        heading : {
          text: M.DIGITAL_PRODUCT_NAME,
          style: {
            fontFamily: 'Arial',
            fontSize: '16',
            lineHeight: '1.6',
            color: '#44474f',
            fontWeight: '700'
          }
        },
        footer:  {
          text: M.DOWNLOAD_WIDGET_EXPIRES,
          style: {
            fontFamily: 'Arial',
            fontSize: '16',
            color: '#44474f',
            fontWeight: '400'
          }
        },
        button: {
          type: component,
          text: M.DOWNLOAD,
          buttonStyle: generateButtonStyle(),
        },
        style: {
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        }
      };

    default:
      return {
        style: {
          color: '#000000',
          backgroundColor: '#ffffff',
          paddingTop: '40px',
          paddingBottom: '40px'
        },
        content: '<div style="font-size: 14px; line-height: 1.3; margin: 0 0 10px 0; text-align: center;">' + M.SAMPLE_HEADING_TOP_TEXT + '</div>' +
            '<div style="font-size: 32px; line-height: 1.3; text-align: center; font-weight: 700;"><span style="font-size: 48px;">' + M.SAMPLE_HEADING_TEXT + '</span><br/><br/></div>' +
            '<div style="font-size: 16px; line-height: 1.5; text-align: center;">' + M.LOREM_IPSUM + '</div>'
      };
  }
}

/**
 * Mapping of blocks for rendering into the builder
 * @returns
 */
export function render() {
  return {
    [TEXT_BUTTON]: TextButtonBlock,
    [IMAGE_HEADER]: ImageHeader,
    [IMAGE_MENU_HEADER]: ImageMenuHeader,
    [IMAGE]: Image,
    [BUTTON]: Button,
    [TEXT_BUTTON_HORIZONTAL]: TextButtonHorizontal,
    [IMAGE_TEXT]: ImageText,
    [HERO_OVERLAY_IMAGE]: HeroOverlayImage,
    [HERO_IMAGE]: HeroImage,
    [STORE_PRODUCT_ONE]: StoreProductsOne,
    [STORE_PRODUCT_TWO]: StoreProductTwo,
    [TESTIMONIAL_DOUBLE]: TestimonialDouble,
    [TESTIMONIAL_SINGLE]: TestimonialSingle,
    [COUPON_CODE_BLOCK]: CouponCodeBlock,
    [COUPON_CODE]: CouponCode,
    [IMAGE_MENU_HORIZONTAL]: ImageMenuHorizontal,
    [SEPARATOR]: Separator,
    [PARAGRAPH_TWO]: ParagraphTwo,
    [VIDEO]: Video,
    [VIDEO_TEXT]: VideoText,
    [FOOTER_ONE]: FooterOne,
    [FOOTER_TWO]: FooterTwo,
    [FOOTER_THREE]: FooterThree,
    [UNSUBSCRIBE]: Unsubscribe,
    [COUNTDOWN_TIMER]: CountdownTimer,
    [WL_LOGO]: WLImageHeader,
    [BOOKING_ANSWERS]: Separator,
    [CART_DETAILS]: CartDetails,
    [ORDER_DETAILS]: OrderDetails,
    [DOWNLOAD]: Download,
  };
}

/**
 * Mapping of controls rendering into the toolbox
 * @returns
 */
export function toolboxRender() {
  return {
    [TEXT_BUTTON]: TextButtonToolBox,
    [IMAGE_HEADER]: ImageHeaderControl,
    [IMAGE_MENU_HEADER]: ImageMenuHeaderControl,
    [IMAGE]: ImageControl,
    [VIDEO]: VideoControl,
    [VIDEO_TEXT]: VideoControl,
    [BUTTON]: ButtonControl,
    [TEXT_BUTTON_HORIZONTAL]: TextButtonHorizontalControl,
    [IMAGE_TEXT]: ImageTextControl,
    [HERO_OVERLAY_IMAGE]: HeroOverlayImageControl,
    [HERO_IMAGE]: HeroImageControl,
    [STORE_PRODUCT_ONE]: StoreProductsOneControl,
    [STORE_PRODUCT_TWO]: StoreProductTwoControl,
    [TESTIMONIAL_DOUBLE]: TestimonialDoubleControl,
    [TESTIMONIAL_SINGLE]: TestimonialSingleControl,
    [COUPON_CODE_BLOCK]: CouponCodeControl,
    [COUPON_CODE]: CouponCodeControl,
    [IMAGE_MENU_HORIZONTAL]: ImageMenuHeaderControl,
    [SEPARATOR]: SeparatorControl,
    [FOOTER_ONE]: FooterOneControl,
    [FOOTER_TWO]: FooterOneControl,
    [FOOTER_THREE]: FooterOneControl,
    [UNSUBSCRIBE]: UnsubscribeControl,
    [COUNTDOWN_TIMER]: CountdownTimerControl,
    [WL_LOGO]: WLImageHeaderControl,
    [BOOKING_ANSWERS]: BookingAnswersControl,
    [ORDER_DETAILS]: OrderDetailsControl,
    [DOWNLOAD]: DownloadControl
  };
}

/**
 * Toolbox blocks menu items
 * @returns
 */
export function toolboxMenuRender(meta, features) {
  let menu = [
    HEADING_ONE,
    PARAGRAPH_ONE,
    PARAGRAPH_TWO,
    SIMPLE,
    TEXT_BUTTON,
    BUTTON,
    IMAGE,
    VIDEO,
    VIDEO_TEXT,
    IMAGE_HEADER,
    IMAGE_MENU_HEADER,
    IMAGE_MENU_HORIZONTAL,
    TEXT_BUTTON_HORIZONTAL,
    IMAGE_TEXT,
    HERO_OVERLAY_IMAGE,
    HERO_IMAGE,
    ...(features.hasCartWidget ? [CART_DETAILS] : []),
    STORE_PRODUCT_ONE,
    STORE_PRODUCT_TWO,
    ...(features.hasOrderDetailsWidget ? [ORDER_DETAILS] : []),
    ...(features.hasDownloadWidget ? [DOWNLOAD] : []),
    TESTIMONIAL_DOUBLE,
    TESTIMONIAL_SINGLE,
    COUPON_CODE,
    COUPON_CODE_BLOCK,
    COUNTDOWN_TIMER,
    SEPARATOR,
    FOOTER_ONE,
    FOOTER_TWO,
    FOOTER_THREE,
    UNSUBSCRIBE
  ];

  if (meta && meta.name) {
    switch (meta.name) {
      case 'data_request':
      case 'new_payment':
      case 'store_subscription_canceled':
        menu.push(WL_LOGO);
        break;
      case 'booking_admin_notification':
        menu.push(BOOKING_ANSWERS);
        break;
    }
  }

  return menu;
}

export function toolboxTextMenuRender() {
  return [
    PARAGRAPH_ONE,
    BUTTON,
    IMAGE,
    VIDEO,
    UNSUBSCRIBE
  ];
}

export function fixMissingProperties(elements) {
  (elements || []).forEach(element => {
    switch(element.type) {
      case FOOTER_ONE:
      case FOOTER_TWO:
      case FOOTER_THREE:
      case UNSUBSCRIBE:
        if (!element.style.brandColor) {
          element.style.brandColor = '#969AA1';
        }
        break;
    }
  });
}
